<template>
    <BaseAvatar
        :class="classObject"
        data-spec-class="pagination-link"
        :data-spec-value="type"
    >
        <slot />
    </BaseAvatar>
</template>

<script setup lang="ts">
import { withDefaults, defineProps, computed } from 'vue';
import { PaginationLinkType, Theme } from '@/types';
import BaseAvatar from './BaseAvatar.vue';

interface Props {
    type?: PaginationLinkType;
    theme?: Theme;
}

const props = withDefaults(defineProps<Props>(), {
    type: PaginationLinkType.Normal,
    theme: Theme.Light,
});

const classObject = computed(() => ({
    'px-2 font-mono transition-ease': true,

    // normal
    '!bg-transparent cursor-pointer': props.type === PaginationLinkType.Normal,

    '!text-secondary hover:!bg-secondary--inverse':
        props.type === PaginationLinkType.Normal && props.theme === Theme.Light,
    '!text-gray-100 hover:!bg-gray-400':
        props.type === PaginationLinkType.Normal && props.theme === Theme.Dark,

    // current
    '!bg-tertiary !text-primary--inverse':
        props.type === PaginationLinkType.Current && props.theme === Theme.Light,
    '!bg-gray-300 !text-gray-900':
        props.type === PaginationLinkType.Current && props.theme === Theme.Dark,

    // disabled
    '!bg-transparent cursor-default': props.type === PaginationLinkType.Disabled,
    '!text-secondary': props.type === PaginationLinkType.Disabled && props.theme === Theme.Light,
    '!text-gray-500': props.type === PaginationLinkType.Disabled && props.theme === Theme.Dark,
}));
</script>
